import { useStore as useReduxStore } from 'react-redux';
import useFetch from '@hooks/useFetch';
import { emptyObject } from '@constants/empty';
import customFetcher from '@utils/api-helper/fetch';

export const getKey = (courseUID) =>
  `v2/collection/${courseUID}/similar_courses/`;

const useSimilarPlusCourses = (
  courseUID,
  options = {
    revalidateOnMount: false,
    fallbackData: undefined
  }
) => {
  const store = useReduxStore();
  const key = getKey(courseUID);

  const {
    data: similarCourses,
    isValidating,
    mutate,
    ...rest
  } = useFetch(
    key,
    {},
    {
      revalidateOnMount: options.revalidateOnMount,
      fallbackData: options.fallbackData
    }
  );

  const onToggleEnroll = async (
    similarCourseUID,
    isEnrolled,
    sendEmail = false,
    prodigyKey = null
  ) => {
    try {
      await customFetcher(`v2/uplus/programmes/${similarCourseUID}/save/`, {
        dispatch: store.dispatch,
        getState: store.getState,
        requestType: 'POST',
        body: {
          enroll: isEnrolled,
          send_email: sendEmail,
          prodigy_key: prodigyKey
        }
      });

      return await mutate();
    } catch (err) {
      return {
        error: {
          message: `Unable to ${
            !isEnrolled ? 'enroll' : 'un-enroll'
          }. Please try again!`
        }
      };
    }
  };

  return {
    key,
    similarCourses: similarCourses || emptyObject,
    isValidating,
    mutate,
    ...rest,
    onToggleEnroll
  };
};

export default useSimilarPlusCourses;
